var map = {
	"./asian-beef-1.jpg": "65cd",
	"./asian-beef-noodles-1.jpg": "5c5f",
	"./asian-chicken-broccoli-1.jpg": "6700",
	"./asian-chicken-broccoli-2.jpg": "d485",
	"./asian-fish-1.jpg": "b976",
	"./asian-noodle-soup-1.jpg": "f969",
	"./asian-noodles-1.jpg": "b3d1",
	"./asian-noodles-2.jpg": "05b1",
	"./asian-salad-1.jpg": "d35e",
	"./asian-soup-1.jpg": "59ab",
	"./asian-special-1.jpg": "3443",
	"./asian-special-2.jpg": "641e",
	"./asian-specialities-1.jpg": "0040",
	"./asian-starters-1.jpg": "626f",
	"./asian-thick-noodles-1.jpg": "4732",
	"./asian-vegetables-1.jpg": "9aad",
	"./auflauf-1.jpg": "2436",
	"./beef-1.jpg": "e4fb",
	"./beer-1.jpg": "6f8c",
	"./beer-2.jpg": "ab33",
	"./burger-1.jpg": "8c3c",
	"./burger-2.jpg": "a96e",
	"./burger-menu-1.jpg": "8054",
	"./chicken-meal-1.jpg": "6aac",
	"./children-potatoes-1.jpg": "3274",
	"./dessert-1.jpg": "fe8f",
	"./dimsum-1.jpg": "5c62",
	"./dimsum-2.jpg": "24b27",
	"./dimsum-3.jpg": "7c83",
	"./dimsum-4.jpg": "9196",
	"./doener-1.jpg": "316a",
	"./doener-2.jpg": "d9e2",
	"./drinks-1.jpg": "d97b",
	"./finger-food-1.jpg": "86ee",
	"./finger-food-2.jpg": "3ef2",
	"./fish-1.jpg": "54cd",
	"./fish-2.jpg": "8f88",
	"./hot-wings-1.jpg": "1797",
	"./italian-salad-1.jpg": "fa0b",
	"./jiaozi-1.jpg": "5e91",
	"./noodles-1.jpg": "e6e1",
	"./noodles-2.jpg": "60de",
	"./onion-rings-1.jpg": "74c5",
	"./pasta-1.jpg": "4b5b",
	"./pasta-2.jpg": "698a",
	"./peking-duck-1.jpg": "b6f2",
	"./pizza-1.jpg": "e613",
	"./pizza-2.jpg": "4a58",
	"./pizza-3.jpg": "ca2c",
	"./pizza-4.jpg": "cc83",
	"./pizza-5.jpg": "a475",
	"./pizza-6.jpg": "48dc",
	"./pizza-with-hand-1.jpg": "7f61",
	"./pizzeriano3-nachspeisen.jpg": "f597",
	"./pizzeriano3-nudeln.jpg": "4d0e",
	"./pizzeriano3-pizzas-2.jpg": "f717",
	"./pizzeriano3-pizzas-3.jpg": "41e5",
	"./pizzeriano3-pizzas.jpeg": "49ac",
	"./pizzeriano3-salat.jpg": "743d",
	"./private-napolimania-fish-1.jpg": "2dd2",
	"./private-napolimania-meat-1.jpg": "9906",
	"./private-napolimania-pasta-1.jpg": "4823",
	"./private-napolimania-pasta-2.jpg": "d369",
	"./private-napolimania-pizza-1.jpg": "eb4a",
	"./private-napolimania-pizza-2.jpg": "2ca4",
	"./private-napolimania-salad-1.jpg": "b532",
	"./private-napolimania-tiramisu-1.jpg": "b69f",
	"./private-pizzeriano3-nachspeisen.jpg": "63e1",
	"./private-pizzeriano3-nudeln.jpg": "8fa0",
	"./private-pizzeriano3-pizzas-2.jpg": "b104",
	"./private-pizzeriano3-pizzas-3.jpg": "9e29",
	"./private-pizzeriano3-pizzas.jpeg": "fb89",
	"./private-pizzeriano3-salat.jpg": "b6a8",
	"./rice-1.jpg": "302d",
	"./salsa-1.jpg": "f6e6",
	"./sandwich-1.jpg": "e88d",
	"./schiffchen-2.jpg": "10b7",
	"./shrimps-1.jpg": "c6e7",
	"./shrimps-2.jpg": "8754",
	"./thai-curry-1.jpg": "f317",
	"./tiramisu-1.jpg": "c350",
	"./tiramisu-2.jpg": "ea3b",
	"./tomato-rice-1.jpg": "9dc6",
	"./udon-noodles-1.jpg": "71da",
	"./vegetables-1.jpg": "74fe",
	"./wine-1.jpg": "9c1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e5c";